import React, { Fragment } from 'react'
// import LoaderImg from "../images/loader.gif"
import "./loading.css"

const Loader = () => {
  return (
    <Fragment>
      <section className="flex w-[100vw] h-[100vh] fixed z-[999999999] justify-center items-center top-0 left-0 bg-white">
        <span className="loader" ></span>
      </section>
    </Fragment>
  )
}

export default Loader